import moment from 'moment'

export default {
  userprofiles (state) {
    return state.userprofiles
  },

  getAuditLogByDay (state) {
    return state.auditlog
  },

  alerts (state) {
    return state.alerts
  },
  getmlresults (state) {
    return state.mlresults
  },
  getccSites (state) {
    return state.ccsites
  },
  getkcSites (state) {
    return state.kcsites
  },
  getNamsysSites(state) {
    return state.nssites
    },
  getNamsysTransactionDetail (state) {
    return state.transactionDetail 
  },
  getssSites (state) {
    return state.sssites
  },
  getKapchargeSites (state) {
    return state.kcsites
  },
  getCashConnectSites (state) {
    return state.ccsites
  },
  getloading (state) {
    return state.isloading
  },
  userinstitutions (state) {
    return state.userinstitutions
  },
  getFISiteList(state) {
    return state.mlinstdata
  },
  getPingsList (state) {
    return state.pinglist
  },
  getSeqFeedData (state) {
    return state.seqfeeddata
  },
  gettotalcash (state) {
    return state.dailytotals
  },
  getVaultAIData (state) {
    return state.aivaultdata
  },
  getVaultAIContext(state) {
    return state.aivaultcontext
  },
  getFeedData (state) {
    return state.feedData
  },
  getSSFeedData (state) {
    return state.feedSSData
  },
  getEstateNoteCount (state) {
    return state.estatenotecount
  },
  getSystemSnap (state, payload) {
    return state.systemsnap
  },
  loadedSites (state) {
    // filter
    let filter = []
    if (state.user.status === 'admin' || state.user.status === 'CashConnect') {
      return state.loadedSites
    } else if (state.user.institution) {
      let userinst = state.userinstitutions.find(inst => inst.key === state.user.institution.key)
      console.log('this users inst is ', userinst)
      if (userinst.sitekeys) {
        let usersites = []
        state.loadedSites.forEach(site => {
          userinst.sitekeys.forEach(key => {
            if (key === site.sitekey) {
              usersites.push(site)
            }
          })
        })
        console.log('we returned a few sites ', usersites.length)
        return usersites
      }
    } else {
      filter = state.loadedSites.filter(site => site.group === state.user.group)
      return filter
    }
  },
  notereaderjams (state) {
    return state.notereaderjams
  },
  notereaderjamlist (state) {
    return state.notereaderjamlist
  },
  notereaderevents (state) {
    return state.notereaderevents
  },
  notereadereventlist (state) {
    return state.notereadereventlist
  },
  loadedPendingDeposits (state) {
    return state.pendingdeposits
  },
  loadedCompletedDeposits (state) {
    return state.completeddeposits
  },
  loadedPostalPackages (state) {
    return state.packages
  },
  getgrosspostaldeposits (state) {
    return state.grosspostaldeposits
  },
  getgrossvalidated (state) {
    return state.grossvalidated
  },
  getgrosssumbyday (state) {
    return state.grosssumbyday
  },
  balancevalues (state) {
    return state.sitebalancevalues
  },
  getpostalchecks (state) {
    return state.postalchecks
  },
  userdeposits (state) {
    return state.userdeposits
  },
  getFISiteAnalysis (state) {
    return state.aidataAnalysis
  },
  getMlInstData(state) {
    return state.mlinstdata
  },
  getManualDeposits (state) {
    return state.manualdeposits
  },
  getSeqDataPublished (state) {
    return state.seqDataPublished
  },
  loadedSiteProfiles (state) {
    let filter = []
    console.log('getting site profiles for user ', state.user.status)
    if (state.user.status === 'admin' || state.user.status === 'CashConnect') {
      console.log('user is admin or cash connect', state.siteprofiles)

      return state.siteprofiles
    } else if (state.user.institution && state.user.status !== 'admin') {
      let allowedprofiles = []
      console.log('inst list set is ', state.userinstitutions)
      console.log('we are loading something special here for inst type user !!!!', state.userinstitutions, state.user.institution.name)
      let userinst = state.userinstitutions.find(inst => inst.key === state.user.institution.key)
      console.log('this users inst is ', userinst)
      if (userinst.sitekeys && userinst) {
        let usersites = []
        state.loadedSites.forEach(site => {
          userinst.sitekeys.forEach(key => {
            if (key === site.sitekey) {
              usersites.push(site)
            }
          })
        })
        // now we have a list of sites, get and return their profiles
        usersites.forEach(site => {
          if (state.siteprofiles[site.idnum]) {
            console.log(' another one ', state.siteprofiles[site.idnum])
            Object.assign(allowedprofiles, { [site.idnum]: state.siteprofiles[site.idnum] })
          }
        })
        console.log('this user can see these sites ', usersites)
        return allowedprofiles
      }
      // state.institution.
      // get the sites where the keys match
      // return their profiles
      // get that institution
    } else {
      let grp = state.user.group
      let keys = Object.keys(state.siteprofiles)
      console.log('user is not inst user, user is ', state.user)
      for (let index in keys) {
        if (state.siteprofiles[keys[index]].group === grp) {
          let k = keys[index]
          let obj = state.siteprofiles[keys[index]]
          // whacky syntax [k] is the literal value of k, and this is a look up table NOT AN ARRAY! this is DESIGNED FOR SPEED
           Object.assign(filter, { [k]: obj })
        }
      }
      return filter
    }
  },
  transactioncount (state) {
    return state.loadedOrders.length
  },
  totalprofit (state) {
    return state.dailyprofit
  },
  machinecount (state) {
    return state.loadedSites.length
  },
  activemachines (state) {
    const unique = [...new Set(state.loadedOrders.map(data => data.machineid))]
    return unique.length
  },
  inactivemachines () {

  },
  ssunits (state) {
    return state.ssunits
  },
  getreleases (state) {
    return state.rels
  },
  alerts (state) {
    return state.alerts
  },
  depositusers (state) {
    return state.depositusers
  },
  getwalletusers (state) {
    return state.loadedwalletusers
  },
  getloading (state) {
    return state.isloading
  },
  getloadingTokens (state) {
    return state.isloadingtokens
  },
  getWeather (state) {
    return state.weatherdata
  },
  cashinvalues (state) {
    return state.sitecashinvalues
  },
  cashingroupvalues (state) {
    return state.cashingroupvalues
  },
  setCITGroupValues (state) {
    return state.groupcitvalues
  },
  getCITGroupValues (state) {
    return state.groupcitvalues
  },
  getLoadedSecureBagDeposits (state) {
    return state.securebag
  },
  getLoadedPostalOrders (state) {
    return state.postalorders
  },
  getChangeOrders (state) {
    return state.changeorders
  },
  getChangeSchedules (state) {
    return state.changeschedules
  },
  getFilledChangeOrders (state) {
    return state.filledorders
  },
  getLoadedChangeProfiles (state) {
    return state.changeprofiles
  },
  getLoadedPostalShipments (state) {
    return state.postalshipments
  },
  getGroupShipments (state) {
    return state.GroupShipments
  },
  getLoadedInHouseShipments (state) {
    return state.inhouseshipments
  },
  getLoadedBillingProfiles (state) {
    return state.billingprofiles
  },
  getstackerevents (state) {
    return state.stackerevents
  },
  getsystemevents (state) {
    return state.systemevents
  },
  getLoadedPostalBags (state) {
    return state.postalbags
  },
  getLoadedPostalDeposits (state) {
    return state.postaldeposits
  },
  getgrouppickups (state) {
    console.log('pickups ', state.grouppickups.length)
    return state.grouppickups
  },
  getGroupShipments (state) {
    return state.GroupShipments
  },
  citevents (state) {
    return state.citevents
  },
  getGroupBalance (state) {
    return state.groupbalance
  },
  sitedeposits (state) {
    return state.sitedeposits
  },
  balancevalues (state) {
    return state.sitebalancevalues
  },
  feesdaily (state) {
    return state.dailyfees
  },
  totaldailysales (state) {
    return state.totaldailysales
  },
  btcexchangeprice (state) {
    return state.btcexchangeprice
  },
  btcspotprice (state) {
    return state.btcspotprice
  },
  uniqueusers (state) {
    return state.totaluniqueusers
  },
  loadedExchangeRate (state) {
    return state.loadedExchangeRate
  },
  userdisplayname (state) {
    return state.userdisplay
  },
  userdisplaybio (state) {
    return state.userbio
  },
  userdisplaylevel (state) {
    return state.userlevel
  },
  userdisplaypoints (state) {
    return state.userpoints
  },
  usergroups (state) {
    if (state.user.status === 'admin' || state.user.status === 'CashConnect') {
      console.log('groups ', state.usergroups)
      return state.usergroups
    } else if (state.user.institution) {
      // get their sites,
      // find the groups in those sites
      // put in an array and return them
      let userinst = state.userinstitutions.find(inst => inst.key === state.user.institution.key)
      console.log('this users inst is ', userinst)
      if (userinst.sitekeys) {
        let usersites = []
        state.loadedSites.forEach(site => {
          userinst.sitekeys.forEach(key => {
            if (key === site.sitekey) {
              usersites.push(site)
            }
          })
        })
        console.log('we returned a few sites ', usersites.length)
        const unique = [...new Set(usersites.map(data => data.group))]
        let allowedgroups = []
        unique.forEach(entry => {
          state.usergroups.forEach(grp => {
            if (grp.name === entry) {
              allowedgroups.push(grp)
            }
          })
        })
        console.log('our groups for inst ', unique)
        return allowedgroups
      }
    } else {
      let filter = state.usergroups.filter(group => group.name === state.user.group)
      return filter
    }
  },
  userdisplaystatus (state) {
    return state.userstatus
  },
  getDimebankSite (state) {
    return state.isDimebankSite
  },
  getbillingclients (state) {
    return state.billingclients
  },
  user (state) {
    return state.user
  },
  getChaseAEGSite (state) {
    return state.isChaseAEGSite
  },
  loading (state) {
    return state.loading
  },

  error (state) {
    return state.error
  },
  getSystemData (state, payload) {
    return state.systemdata
  },
  getheartbeatvalues (state) {
    return state.heartbeatvalues
  },
  safesstatus (state) {
    return state.safes
  },
  estatesums (state) {
    return state.estatesums
  },
  getCheckedPackages (state) {
    return state.checkedPackages
  },
  getreconsilebyday (state) {
    // timestamp type sum
    let records = []
    for (let i in state.citevents) {
      // normalise for the day the safe is located in
      let day = moment(state.citevents[i].timestamp).subtract(7, 'hours').format('YYYY-MM-DD')
      records.push({ day: day, type: 'cit', sum: state.citevents[i].total })
    }
    // sum the cit days
    let udays = [...new Set(records.map(data => data.day))]
    let summedcit = []
    for (let k = 0; k < udays.length; k++) {
      // lets group them by the day here
      let filterbyday = records.filter(function (order) {
        return order.day === udays[k]
      })
      // now get the sum of the sales that are on the same day
      if (filterbyday) {
        let s = filterbyday.reduce((a, b) => a + ((b['sum']) || 0), 0)
        summedcit.push({ day: udays[k], type: 'cit', sum: s })
      }

      // s = numeral(s).format('$0,0.00')
      // now push the day and the sum to sumperday array (day: "dayvalue",sum:"suminpennies")
    }
    // now get the sum of the sales that are on the same day
    // eod recs are once per day so no need to sum
    let eodrecords = []
    for (let j in state.sitecashinvalues) {
      eodrecords.push({ day: state.sitecashinvalues[j].day, type: 'eod', sum: state.sitecashinvalues[j].sum })
    }
    // loop thru the eods and create new record that shows day - cit - eod - total
    let totalrec = []
    for (let i in eodrecords) {
      let rec = { day: eodrecords[i].day, eod: eodrecords[i].sum, cit: 0, total: eodrecords[i].sum, split: 0, presplit: 0 }
      for (let j in summedcit) {
        if (eodrecords[i].day === summedcit[j].day) {
          let splitsumforday = 0
          let presplitsumforday = 0
          rec.eod = eodrecords[i].sum
          rec.cit = summedcit[j].sum
          rec.split = splitsumforday
          rec.presplit = presplitsumforday
        }
      }
      totalrec.push(rec)
    }
    return totalrec
  },
  getAllPackageTrackingNumbers (state) {
    return state.allPackageTrackingNumbers
  },
  getShipmentDetail (state) {
    return state.shipmentDetail
  },
  getCheckedDetail (state) {
    return state.checkedDetail
  },
  getFIEODs (state) {
    return state.fieods
  },
  getSafeFobs (state) {
    return state.keyfobs
  },
}
